import type { QueryClient } from "@tanstack/react-query";
import { redirect } from "@tanstack/react-router";
import { api } from "./api";
import { hasName, isOps } from "./auth";
import type { IUser } from "./proto";

export async function requireCustomer(queryClient: QueryClient): Promise<IUser> {
  const me = await queryClient.ensureQueryData({ queryKey: ["me"], queryFn: () => api.me() });
  if (isOps(me)) throw redirect({ to: "/ops" });
  if (!hasName(me)) throw redirect({ to: "/onboarding" });
  return me;
}
